var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPieces = function SvgPieces(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M12 4v4.923m1.846 8h3.077M4 8.923h16m-16 0v9.846A1.23 1.23 0 0 0 5.23 20h13.54A1.23 1.23 0 0 0 20 18.77V8.922m-16 0 1.846-3.557A2.46 2.46 0 0 1 7.988 4h8.024a2.46 2.46 0 0 1 2.203 1.366L20 8.923"
  })));
};
export default SvgPieces;